import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./Footer.css";

function Footer() {
  const { t } = useTranslation();

  const phoneNumber = "96170210576";

  const whatsappLink = `https://wa.me/${phoneNumber}`;

  return (
    <footer className="luxury-footer">

      {/* ==================================================
          DECORATIVE TOP
      ================================================== */}

      <div className="footer-top-decoration">
        <span></span>
        <i>✦</i>
        <span></span>
      </div>


      {/* ==================================================
          MAIN BRAND
      ================================================== */}

      <section className="footer-intro">

        <span className="footer-eyebrow">
          {t("footer.eyebrow")}
        </span>

        <h2>
          {t("footer.title1")}
          <br />
          <em>{t("footer.title2")}</em>
        </h2>

        <p>
          {t("footer.intro")}
        </p>

        <Link
          to="/contact"
          className="footer-main-button"
        >
          <span>
            {t("footer.bookNow")}
          </span>

          <strong>↗</strong>
        </Link>

      </section>


      {/* ==================================================
          FOOTER NAVIGATION
      ================================================== */}

      <section className="footer-navigation">

        {/* BRAND */}

        <div className="footer-brand-column">

          <div className="footer-logo">
            <span>O</span>
            <div>
              <strong>Omaya Eid</strong>
              <small>PHOTOGRAPHY</small>
            </div>
          </div>

          <p>
            {t("footer.description")}
          </p>

          <div className="footer-socials">

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              IG
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
            >
              WA
            </a>

          </div>

        </div>


        {/* EXPLORE */}

        <div className="footer-column">

          <span className="footer-column-title">
            {t("footer.explore")}
          </span>

          <Link to="/">
            {t("footer.home")}
          </Link>

          <Link to="/about">
            {t("footer.about")}
          </Link>

          <Link to="/photography">
            {t("footer.photography")}
          </Link>

          <Link to="/rental">
            {t("footer.rental")}
          </Link>

          <Link to="/contact">
            {t("footer.contact")}
          </Link>

        </div>


        {/* PHOTOGRAPHY */}

        <div className="footer-column">

          <span className="footer-column-title">
            {t("footer.photographyCollections")}
          </span>

          <Link to="/gallery/Photography/Weddings">
            {t("footer.weddings")}
          </Link>

          <Link to="/gallery/Photography/Engagements">
            {t("footer.engagements")}
          </Link>

          <Link to="/gallery/Photography/Bridal%20Sessions">
            {t("footer.bridalSessions")}
          </Link>

          <Link to="/gallery/Photography/Women%20Events">
            {t("footer.womenEvents")}
          </Link>

          <Link to="/gallery/Photography/Family%20%26%20Friends">
            {t("footer.familyFriends")}
          </Link>

        </div>


        {/* RENTAL */}

        <div className="footer-column">

          <span className="footer-column-title">
            {t("footer.rentalCollections")}
          </span>

          <Link to="/gallery/Rental/Bridal%20Robes">
            {t("footer.bridalRobes")}
          </Link>

          <Link to="/gallery/Rental/Bridesmaids%20Robes">
            {t("footer.bridesmaids")}
          </Link>


        </div>

      </section>


      {/* ==================================================
          CONTACT STRIP
      ================================================== */}

      <section className="footer-contact-strip">

        <div className="footer-contact-item">

          <span>
            {t("footer.contactLabel")}
          </span>

          <a href={whatsappLink}>
            +961 70 210 576
          </a>

        </div>


        <div className="footer-contact-item">

          <span>
            {t("footer.socialLabel")}
          </span>

          <a
            href="https://www.instagram.com/oumayaeid?igsh=cnlmY29mZjZydm9r&igsi=cnlmY29mZjZydm9r"
            target="_blank"
            rel="noreferrer"
          >
            @WomenPhotographer
          </a>

        </div>


        <div className="footer-contact-item footer-contact-action">

          <Link to="/contact">
            {t("footer.sendRequest")}
            <strong>↗</strong>
          </Link>

        </div>

      </section>


      {/* ==================================================
          BOTTOM
      ================================================== */}

      <section className="footer-bottom">

        <p>
          © {new Date().getFullYear()} Omaya Eid.
          {" "}
          {t("footer.rights")}
        </p>

        <div className="footer-bottom-center">
          ✦
        </div>

        <p>
          {t("footer.madeWith")}
          {" "}
          <span>♡</span>
          {" "}
          {t("footer.forBeautifulMoments")}
        </p>

      </section>

    </footer>
  );
}

export default Footer;